export default "__VITE_ASSET__BxQq_1fG__"